import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GeneralService } from './general.service';
import { HttpClient } from '@angular/common/http';
import { QuotationModel } from '../models/quotation-model/quotation.model';
import { catchError, Observable, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuotationService {
  public URL_API = environment.apiURLNew;
  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getQuotationProgress(userId: number): Observable<QuotationModel[] | null> {
    const params = this.generalService.buildParams({ userId });
    return this.http.get<QuotationModel[]>(this.URL_API + `/prequote/list`, { params }).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }
}
